import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-6-5.4l3 2.4V7l-3 2.4V7H7v6h7z"
}), 'VoiceChatOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VoiceChatOutlined.js
// module id = 7146
// module chunks = 2